import type { ReactNode } from 'react'

interface IconProps {
  size?: number
  className?: string
}

/**
 * Small stroke icons (lucide-style, 24×24 viewBox, `currentColor`). Decorative
 * by default (`aria-hidden`); give the interactive parent an accessible label.
 * Add new glyphs here rather than inlining `<svg>` in components.
 */
function StrokeIcon({ size = 14, className, children }: IconProps & { children: ReactNode }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {children}
    </svg>
  )
}

export function ChevronLeft(props: IconProps) {
  return (
    <StrokeIcon {...props}>
      <polyline points="15 18 9 12 15 6" />
    </StrokeIcon>
  )
}

export function ChevronRight(props: IconProps) {
  return (
    <StrokeIcon {...props}>
      <polyline points="9 18 15 12 9 6" />
    </StrokeIcon>
  )
}

/** Dismiss. */
export function X(props: IconProps) {
  return (
    <StrokeIcon {...props}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </StrokeIcon>
  )
}

/** It worked — the glyph half of a notice, so the tone is never colour alone. */
export function Check(props: IconProps) {
  return (
    <StrokeIcon {...props}>
      <polyline points="20 6 9 17 4 12" />
    </StrokeIcon>
  )
}

/** It did not work. Paired with the alert rail for the same reason. */
export function AlertTriangle(props: IconProps) {
  return (
    <StrokeIcon {...props}>
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </StrokeIcon>
  )
}

/** An arrow landing in a tray: pulling something in from outside. */
export function Download(props: IconProps) {
  return (
    <StrokeIcon {...props}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </StrokeIcon>
  )
}
